import { NavLink } from 'react-router-dom';
import { useDataContext } from 'context/DataStoreContext';
import { generalStyle } from 'helper/Style';
import Layout from 'component/part/Layout';
import BackLink from 'component/part/BackLink';
import H2 from 'component/part/H2';
import List, { ListIndex } from 'component/part/List';

const contractorIndexes: ListIndex[] = [
  { label: '業者名', key: 'name' },
];

const ContractorList: React.FC = () => {
  const { state } = useDataContext();
  const { list = [] } = state?.contractor || {};

  const rows = list.map((contractor) => [
    <NavLink to={`/contractor/${contractor.id}`} css={generalStyle.link}>{contractor.name}</NavLink>,
  ]);

  return <Layout>
    <BackLink link='/' label='トップ'></BackLink>
    <H2>元請情報一覧</H2>
    <div css={generalStyle.listLayout}>
      <List type='contractor' indexes={contractorIndexes} rows={rows} />
      <div css={generalStyle.formRow}>
        <NavLink to='/contractor/create' css={generalStyle.button()}>新規登録</NavLink>
      </div>
    </div>
  </Layout>;
};

export default ContractorList;
